export function isBTAdminPath(
  pathname: string = window.location.pathname,
): boolean {
  return pathname.toLowerCase().startsWith("/app/admin");
}
